/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_DomainInputs */

const en_common_domain = /** @type {(inputs: Common_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domain`)
};

const es_common_domain = /** @type {(inputs: Common_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dominio`)
};

/**
* | output |
* | --- |
* | "Domain" |
*
* @param {Common_DomainInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_domain = /** @type {((inputs?: Common_DomainInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_DomainInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_domain(inputs)
	return en_common_domain(inputs)
});